import React, { useState } from "react";
import Header from "../Header";
import Sidebar from "../Sidebar";
import { Link, useLocation, useNavigate } from "react-router-dom";
import FeatherIcon from "feather-icons-react";
import { useSelector } from "react-redux";
import { postReply } from "../../connections/postReply";
import { toast } from "react-toastify";
// import { getQueryDetail } from "../../connections/getQueryDetail";

const ReplyQuires = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const QueryData = location.state || null;
    const [message, setMessage] = useState("");
    const [messages, setMessages] = useState(QueryData?.query_replies || []);


    const {
        user: { user },
    } = useSelector((store) => store);

    // const handleFetchQueryConversation = async () => {
    //     try {
    //         const response = await getQueryDetail(user?.token, QueryData?.id);
    //         if (response?.status?.status) {
    //             setMessages(response?.payload?.query_replies);

    //         }
    //     } catch (error) {
    //         toast.error(error.message || "something went wrong");
    //     }
    // }

    // useEffect(() => {
    //     handleFetchQueryConversation();
    // }, [messages])

    const handleSendMessage = async () => {
        if (!message.trim()) return;
        const query_reply = { message: message };
        try {
            const response = await postReply(user?.token, QueryData?.id, { query_reply });
            if (response?.status?.status) {
                setMessages((prevMessages) => [
                    ...prevMessages,
                    { id: Date.now().toString(), message: message, repliable_type: 'AdminUser' }
                ]);
                setMessage("");
            }
        } catch (error) {
            toast.error(error.message || "something went wrong");
        }
    };


    return (
        <>
            <Header />
            <Sidebar activeClassName="quires" />
            <div className="page-wrapper">
                <div className="content">
                    <div className="page-header">
                        <div className="row">
                            <div className="col-sm-12">
                                <ul className="breadcrumb">
                                    <li className="breadcrumb-item">
                                        <Link to={-1}>Query</Link>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <FeatherIcon icon="chevron-right" />
                                    </li>
                                    <li className="breadcrumb-item active">Reply Query</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="col-12">
                                        <div className="form-heading">
                                            <h4>Reply Query</h4>
                                        </div>
                                    </div>

                                    {/* Chat Messages */}
                                    <div className="chat-box" style={{ maxHeight: "400px", overflowY: "auto", padding: "10px", border: "1px solid #ddd", borderRadius: "5px" }}>

                                        {messages.map((reply) => {
                                            const isCurrentUser = reply.repliable_type !== "Patient";
                                            return (
                                                <div key={reply.id} style={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    alignItems: isCurrentUser ? "flex-end" : "flex-start",
                                                    marginBottom: "10px",
                                                }}>
                                                    <div style={{
                                                        backgroundColor: isCurrentUser ? "#0067FF40" : "#f1f1f1",
                                                        padding: "10px",
                                                        borderRadius: "10px",
                                                        maxWidth: "70%",
                                                        display: 'flex',
                                                        flexDirection: "column",
                                                        gap: -10,
                                                        boxShadow: "0px 1px 3px rgba(0,0,0,0.2)"
                                                    }}>
                                                        {/* <strong>{isCurrentUser ? "You" : reply.repliable_type}</strong> */}
                                                        <p style={{ padding: '0px' }}>{reply.message}</p>
                                                        <small style={{
                                                            fontSize: "12px",
                                                            color: "#777",
                                                            padding: '0px'
                                                        }}>
                                                            {new Date(reply.created_at).toLocaleString()}
                                                        </small>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>

                                    {/* Input Box */}
                                    <div className="input-box" style={{ marginTop: "10px", display: "flex", gap: "10px", alignItems: "center" }}>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Type your message..."
                                            value={message}
                                            onChange={(e) => setMessage(e.target.value)}
                                            style={{ flex: 1 }}
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter") {
                                                    e.preventDefault(); // Prevents form submission (if applicable)
                                                    handleSendMessage();
                                                }
                                            }}
                                        />
                                        <button className="btn btn-primary" onClick={handleSendMessage}>
                                            <FeatherIcon icon="send" size={16} /> Send
                                        </button>

                                        <button className="btn btn-secondary" onClick={() => navigate("/admin/update_quires", { state: QueryData })}>
                                            <FeatherIcon icon="arrow-left" size={16} /> Back
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ReplyQuires;
